var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gl-form-group',{staticClass:"gl-mb-0",attrs:{"label":_vm.$options.i18n.header,"data-testid":"roadmap-epics-state"}},[_c('gl-form-radio-group',{attrs:{"checked":_vm.epicsState,"stacked":"","options":_vm.availableStates},on:{"change":_vm.handleEpicStateChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }